module.exports = __webpack_public_path__ + "static/media/1.ab1e04c0.JPG";